'use client'

import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

export const NavList = ({ error, items = [], icons = {}, sx = {}, linkComponent = 'a' }: any) => {
	if (error) {
		return <Box sx={{ pt: 8 }}>Error: {error.message}</Box>
	}
	return (
		<Box sx={{ pt: 8, ...sx.root }}>
			<List sx={sx.list}>
				{items.length > 0 &&
					items
						.sort((a: any, b: any) => a.sequence - b.sequence)
						.map(({ id, title, url, icon }: any) => {
							const Icon = icons[icon]
							return (
								<ListItem key={id} disablePadding sx={sx.listItem}>
									<ListItemButton component={linkComponent} to={url} sx={sx.listItemButton}>
										{Icon && (
											<ListItemIcon sx={sx.listItemIcon}>
												<Icon sx={sx.icon} />
											</ListItemIcon>
										)}
										<ListItemText primary={title} sx={sx.listItemText} />
									</ListItemButton>
								</ListItem>
							)
						})}
			</List>
		</Box>
	)
}
